module.exports = __webpack_public_path__ + "img/artists.74584ebe.jpg";